import React, { useState } from "react";
import './signin.css';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { Link } from "react-router-dom";

const Signin = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({ email:"", password: "" });
  const [isLoading, setIsLoading] = useState(false);
  const navigate=useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!credentials.email || !credentials.password) {
        toast.warning("Please enter both email and password.");
        return;
    }

    setIsLoading(true);

    try {
        const response = await axios.post("https://backend-n2zq.onrender.com/api/signin", {
            email: credentials.email,
            password: credentials.password,
        });

        toast.success("Sign-in successful!");
        
        setTimeout(() => {
            onLogin(response.data.user);
            navigate("/dashboard"); // Redirect to dashboard after login
        }, 1500);
    } catch (error) {
        toast.error(error.response?.data?.message || "Login failed");
    } finally {
        setIsLoading(false);
    }
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials({ ...credentials, [name]: value });
  };

  return (
    <div className="contain">
      <div>
       <form onSubmit={handleSubmit}>

        <h1>Admin Dashboard</h1>
        <div className="input-container">
          <input
            id="email"
            type="text"
            name="email"
            value={credentials.email}
            onChange={handleChange}/>
          <label>Email</label>
        </div>

        <div className="input-container">
          <input
            id="password"
            type="password"
            name="password"
            value={credentials.password}
            onChange={handleChange}/>
          <label>Password</label>
        </div>
       
  
<Link to="/forgot-password" className="forgot-password-link">
  Forgot Password?
</Link>

       <button type="submit" disabled={isLoading}>
          {isLoading ? "Loading..." : "Sign In"}
        </button>

        <p> Don't have an account?
        <Link to="/sign-up" >Signup</Link>
        </p>
      </form>
      </div>

      <div>
      <ToastContainer />
      </div>

    </div>
  );

};

export default Signin;



